import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Col, Row } from "react-grid-system";
import { BiExit } from "react-icons/bi";
import { AiOutlineMenu } from "react-icons/ai";
import { useTranslation } from "react-i18next";

import mainStore from "../../store/index";

import { getDatabase, ref, onValue } from "firebase/database";

import Menu from "./Menu";

export default function Header(props: any) {
  const [t, i18n] = useTranslation("global");

  const STORE = mainStore();

  const [logo, setLogo] = React.useState<string>("");
  const [openmenu, setOpenMenu] = React.useState<boolean>(false);
  const [bussine, setBussineData] = React.useState<any>(null);
  const [isLoader, setLoader] = React.useState(false);

  React.useEffect(() => {
    getDataRestaurant();
    console.log(props, "props klk");
  }, [STORE]);

  const exitAccount = () => {
    const con = window.confirm(
      "Estas seguro que quieres salir de la cuenta🙉?"
    );

    if (con) {
      STORE.handledLogged(false);
      localStorage.clear();
      window.location.reload();
    }
  };

  const openMenu = () => {
    let open = !openmenu;
    setOpenMenu(open);
  };

  const changeIdiom = (data: any) => {
    i18n.changeLanguage(data);
  };

  const getDataRestaurant = async () => {
    setLoader(true);
    const idLocal: any = localStorage.getItem("localId");
    let data;
    const realtime = getDatabase();
    const starCountRef = ref(realtime, "restaurants/" + idLocal);
    onValue(starCountRef, (snapshot) => {
      if (snapshot.exists()) {
        data = snapshot.val();
        setBussineData(data);
        setLogo(data.logo);
        // getDataSections(data.menu);
        setLoader(false);
      } else {
      }
    });
  };

  return (
    <ContentHeader className="">
      <div className="logo">
        <Link to="/">Menu DR</Link>
      </div>
      <div className="">
        {STORE.is_logged && (
          <Row>
            <Col>
              <ContentProfile>
                <Link to="/admin-restaurant">
                  <img
                    src={
                      logo ||
                      "https://upload.wikimedia.org/wikipedia/commons/8/89/Portrait_Placeholder.png"
                    }
                    alt=""
                  />
                </Link>
              </ContentProfile>
            </Col>

            <Col>
              <AiOutlineMenu
                style={{ fontSize: "1.5em", marginTop: "8px" }}
                onClick={() => openMenu()}
              />
            </Col>
          </Row>
        )}
        {!STORE.is_logged && (
          <Row>
            <Col>
              <Link to="/login">{t("header.login")}</Link>
            </Col>
            <Col>
              <Link to="/register">{t("header.register")}</Link>
            </Col>
            <Col>
              <AiOutlineMenu
                style={{ fontSize: "1.5em" }}
                onClick={() => openMenu()}
              />
            </Col>
          </Row>
        )}
      </div>
      {openmenu && (
        <Menu closeMenu={openMenu} store={STORE} changeIdiom={changeIdiom} />
      )}
    </ContentHeader>
  );
}

const ContentHeader = styled.div`
  width: 100%;
  height: 8vh;
  display: flex;
  flex-direction: row;
  padding: 0 10em;
  justify-content: space-between;
  align-items: center;
  /* background: #D4E9F7; */
  // background: #d4e9f7;
  @media screen and (max-width: 600px) {
    padding: 0 1em;
  }
  a {
    text-decoration: none;
    color: #2c3e50 !important;
  }
  svg {
    color: #2c3e50 !important;
  }
  .logo {
    font-size: 1.2em;
    color: #2c3e50;
    font-weight: bold;
    border-bottom: 1px solid #4834d4;
  }
  span {
    font-size: 1.5em;
  }
  .float_m {
    width: 90%;
    min-height: 20vh;
    position: absolute;
    top: 4em;
    z-index: 10;
    right: 0;
    background: white;
    margin: 0 1em;
    box-shadow: 0px 0px 20px #2c3e5086;
    border-radius: 8px;
    padding: 1em;
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      li {
        padding: 0.3em;
        svg {
          font-size: 1.1em;
          margin: 0 5px;
        }
      }
    }
  }
`;

const ContentProfile = styled.div`
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 50px;
  img {
    width: 100%;
    height: 40px;
    border: 2px solid white;
    border-radius: 50px;
    object-fit: cover;
  }
`;
